import { useRouter } from 'next/navigation';
import { useState } from 'react';

import { useFilterOptions } from '../../../hooks/useFilterData';
import Icon from './Icon';
import SearchModal, { Line } from './SearchModal';

type SearchToolsProps = {};

const SearchTools = ({}: SearchToolsProps) => {
  const router = useRouter();
  const { data: filterData, isLoading } = useFilterOptions();
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const onClose = () => {
    setIsSearchOpen(false);
  };

  const onOpen = () => {
    setIsSearchOpen(true);
  };

  const onSearch = (query: string, selectedLine?: Line) => {
    const params = new URLSearchParams();
    if (query.trim()) {
      params.set('search', query.trim());
    }
    if (selectedLine?.name) {
      params.set('line', selectedLine.name);
    }
    router.push(`/search?${params.toString()}`);
  };

  // Transform filter data lines to SearchModal format
  // FilterItem.value is the unique name (already de-duped by parseCatalogFilters)
  const lines: Line[] =
    filterData?.lines?.map((line) => ({
      id: line.value,
      name: line.label,
      status: 'active',
      description: `${line.count} productos`,
      picture: line.picture || { url: 'https://placehold.co/600x400.png' },
    })) || [];

  return (
    <>
      <div>
        <button type="button" onClick={onOpen} className="flex items-center text-gray-700 hover:text-gray-400 justify-center cursor-pointer" title="Buscar productos">
          <Icon name="search" size={20} />
        </button>
      </div>
      {isSearchOpen && <SearchModal lines={lines} onClose={onClose} isOpen={isSearchOpen} onSearch={onSearch} />}
    </>
  );
};

export default SearchTools;
